module.exports = __webpack_public_path__ + "img/sale-unia.3d9e12a6.jpeg";